module.exports = __webpack_public_path__ + "statics/img/extract-amount-f4839d1c.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/xhpopulrz/download/extract-amount.png
// module id = 1216
// module chunks = 143